
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationType } from './notificationType.enum';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: true,
  imports: [],
})
export class NotificationComponent implements OnInit {
  public notificationString: string;
  public notificationType = NotificationType;

  constructor(
     
    @Inject(MAT_SNACK_BAR_DATA) public notificationData: any,
    public snackBarRef: MatSnackBarRef<NotificationComponent>,
  ) {}

  ngOnInit() {
    this.notificationString = this.notificationData.message;
  }
}
